export default __webpack_public_path__ + "static/media/undraw_secure_login.610c9be7.svg";